import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '@/hooks/useLanguage';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export function CookieConsent() {
  const { t } = useTranslation();
  const { getLocalizedPath } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleConsent = (type: 'accepted' | 'necessary') => {
    localStorage.setItem('cookie-consent', JSON.stringify({ type, date: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className={cn(
        'fixed bottom-0 left-0 right-0 z-50 border-t bg-background/95 backdrop-blur-sm shadow-lg',
        'animate-in slide-in-from-bottom duration-500'
      )}
    >
      <div className="container flex flex-col gap-3 py-4 sm:flex-row sm:items-center sm:justify-between sm:gap-6">
        <p className="text-sm text-muted-foreground">
          {t('cookieConsent.message')}{' '}
          <Link
            to={getLocalizedPath('/cookiepolicy')}
            className="font-medium text-primary underline underline-offset-4 hover:text-primary/80"
          >
            {t('cookieConsent.learnMore')}
          </Link>
        </p>
        <div className="flex shrink-0 gap-2">
          <Button variant="outline" size="sm" onClick={() => handleConsent('necessary')}>
            {t('cookieConsent.onlyNecessary')}
          </Button>
          <Button size="sm" onClick={() => handleConsent('accepted')}>
            {t('cookieConsent.accept')}
          </Button>
        </div>
      </div>
    </div>
  );
}
